export default __webpack_public_path__ + "f15262c91975dc3aff78f8651359d031.svg";